import './Gallery.css';
import { ImageGallery } from '../../components';
import { useEffect } from 'react';

export default function Gallery() {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = 'Prachurya Dash | Gallery';
  });

  return (
    <div className='page-gallery'>
      <ImageGallery />
    </div>
  );
}
